// extracted by mini-css-extract-plugin
export default {"button":"styles_button__+5VC6","button_font":"styles_button_font__aIrul"};